import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "./Api";
import "./ArticlePage.css";
import Header from "./Header";
import Cookies from 'js-cookie';
import { FaBell, FaLinkedin, FaPenAlt, FaRegCalendarAlt, FaThumbsUp, FaWhatsapp, FaBookmark, FaRegBookmark, FaCopy, FaQrcode, FaReply, FaClock } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import Footer from "./Footer";
import TextToSpeech from "./TextToSpeech";

/* Inline skeleton component — no extra file needed */
const ArticleSkeleton = () => (
  <div className="article-page-contener">
    <Header />
    <div className="article-page" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <div className="skeleton skeleton-art-img" />
      <div className="skeleton" style={{ height: '32px', width: '70%', marginBottom: '16px' }} />
      <div className="skeleton" style={{ height: '18px', width: '40%', marginBottom: '24px' }} />
      {[...Array(8)].map((_, i) => (
        <div key={i} className="skeleton" style={{ height: '14px', width: i % 3 === 2 ? '75%' : '100%', marginBottom: '10px' }} />
      ))}
    </div>
  </div>
);

const ArticlePage = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const[user, setUser]=useState();
  const[relatedArticles, setRelatedArticles]=useState([]);
  const[loginStatus, setLoginStatus]=useState(false);
  const[isLiked, setIsLiked]=useState(false);
  const[showLikeError, setShowLikeError]=useState(false);
  // Phase 4 — new states
  const [readingProgress, setReadingProgress] = useState(0);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);
  const [tocItems, setTocItems] = useState([]);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");

  useEffect(() => {
    fetchArticle();
    const username=Cookies.get('username');
    if(username && username.length>0){
      setUser(username);
      setLoginStatus(true);
    }
     // 2. Start loading related articles in background
     fetchRelatedArticles(slug);
  }, [slug]);

  // Reading progress bar
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setReadingProgress(Math.min(100, progress));
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ToC + Bookmark check
  useEffect(() => {
    if (article) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(article.content, 'text/html');
      const headings = doc.querySelectorAll('h2, h3');
      const items = Array.from(headings).map((h, i) => ({
        id: `toc-${i}`,
        text: h.textContent.trim(),
        level: h.tagName.toLowerCase(),
      }));
      setTocItems(items);
      const bookmarks = JSON.parse(localStorage.getItem('dj-bookmarks') || '[]');
      setIsBookmarked(bookmarks.includes(article.slug));
    }
  }, [article]);


// Fetch related articles separately
const fetchRelatedArticles = async (slug) => {
  try {
    const res = await api.get(`/blogs/related/${slug}`);
    setRelatedArticles(
      res.map(article => ({
      ...article,
      // coverImage comes back as a URL path from the backend
      coverImage: article.coverImage || null,
        date: new Date(article.createdAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
      }))
    );
  } catch (err) {
    console.error('Failed to load related articles:', err);
  }
};
  const fetchArticle = async () => {
    try {
      const response = await api.get(`/blogs/read/${slug}`);
      setArticle({
        ...response,
        // coverImage is now a URL path returned by the backend
        coverImage: response.coverImage || null,
        date: new Date(response.createdAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
      });
      fetchComments(response.id);
    } catch (error) {
      alert(`Faild to lead ${slug} Article, Please try again!`);
      console.error("Error fetching article:", error);
      window.location.href = '/';
    }
  };

  const fetchComments = async (articleId) => {
    try {
      // API now returns a Page object; extract .content array
      const response = await api.get(`/blogs/comments/${articleId}`);
      setComments(response.content || response);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  const handleCommentSubmit = async () => {
    if(!user || user.trim() === "") { 
      alert("please login or add user name to comment");
      return;
    }
    if(newComment === "" || newComment.trim() === "") {
      alert("Please add comment to submit")
      return;
    }
    try {
      const commentData = {
        blogId: article.id,
        text: newComment,
        username: user,
      };
      await api.post(`/blogs/${article.id}/comment`, commentData);
      setNewComment();
      setNewComment("");
      await fetchComments(article.id)

    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
 

  const handleLike = async () => {
    try {
      if(isLiked){
        setShowLikeError(true);
        setTimeout(() => {
          setShowLikeError(false);
        }, 3000);
        return;
      }
      await api.post(`/blogs/like/${article.slug}`);
      setArticle({ ...article, likes: article.likes + 1 });
      setIsLiked(true);
    } catch (error) {
      console.error("Error liking article:", error);
    }
  };
  const truncateContent = (content, length = 100) => {
    if (!content) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;
    const plainText = tempDiv.innerText;
    return plainText.length > length ? plainText.substring(0, length) + "..." : plainText;
  };
  const handleCmteLike=async(id)=>{
    try {
      await api.post(`/blogs/comments/${id}/like`);
      setComments(comments.map(comment => 
        comment.id === id ? { ...comment, likes: comment.likes + 1 } : comment
      ));
    } catch (error) {
      console.error("Error liking comment:", error);
    }
  }

  // Phase 4 helpers
  const toggleBookmark = () => {
    const bookmarks = JSON.parse(localStorage.getItem('dj-bookmarks') || '[]');
    const updated = isBookmarked
      ? bookmarks.filter(s => s !== article.slug)
      : [...bookmarks, article.slug];
    localStorage.setItem('dj-bookmarks', JSON.stringify(updated));
    setIsBookmarked(!isBookmarked);
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      alert('Link copied to clipboard!');
    });
  };

  const handleReplySubmit = async (parentId) => {
    if (!user || replyText.trim() === '') return;
    try {
      await api.post(`/blogs/comments/${parentId}/reply?articleId=${article.id}`, {
        text: replyText,
        username: user,
        blogId: article.id,
      });
      setReplyText('');
      setReplyingTo(null);
      fetchComments(article.id);
    } catch (error) {
      console.error('Reply error:', error);
    }
  };

  const calcReadTime = (content) => {
    if (!content) return 5;
    const text = content.replace(/<[^>]+>/g, ' ');
    const words = text.trim().split(/\s+/).length;
    return Math.max(1, Math.round(words / 200));
  };

  useEffect(() => {
    if (article) {
      document.title = `${article.title} - Digital Journaling`;
      const metaDescription = document.querySelector("meta[name='description']");
      if (metaDescription) {
        metaDescription.setAttribute("content", article.description);
      } else {
        const newMetaDescription = document.createElement("meta");
        newMetaDescription.name = "description";
        newMetaDescription.content = article.description;
        document.head.appendChild(newMetaDescription);
      }
    }
  }, [article]);


  if (!article) return <ArticleSkeleton />;

  return (
   <>
    {article && (
    <Helmet>
        <title>{article.title} | Digital Journaling</title>
        <meta name="description" content={(article && article.description) || "Read latest insights on journaling"} />
        <meta property="og:title" content={article && article.title} />
        <meta property="og:description" content={(article && article.description) || "Read latest insights on journaling"}  />
        <meta property="og:image" content={article && article.coverImage ? `https://www.digitaljournaling.com${article.coverImage}` : "https://www.digitaljournaling.com/logo192.png"} />
        <meta property="og:url" content={`https://www.digitaljournaling.com/blog/${article && article.slug}`} />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Digital Journaling" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={article && article.title} />
        <meta name="twitter:description" content={(article && article.description) || "Read latest insights on journaling"} />
        <meta name="twitter:image" content={article && article.coverImage ? `https://www.digitaljournaling.com${article.coverImage}` : "https://www.digitaljournaling.com/logo192.png"} />
        <meta name="keywords" content={`blogs, articles, tech, guides, ${(article && article.tags ? article.tags.join(', ') : '')}`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.digitaljournaling.com/blog/${article && article.slug}`} />
        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": article.title,
          "description": article.description || "",
          "image": article.coverImage ? `https://www.digitaljournaling.com${article.coverImage}` : undefined,
          "author": { "@type": "Person", "name": article.author === "sushensable" ? "Sushen Sable" : article.author },
          "publisher": { "@type": "Organization", "name": "Digital Journaling", "url": "https://www.digitaljournaling.com" },
          "datePublished": article.createdAt,
          "dateModified": article.updatedAt || article.createdAt,
          "url": `https://www.digitaljournaling.com/blog/${article.slug}`,
          "keywords": article.tags ? article.tags.join(", ") : ""
        })}</script>
      </Helmet>
    )}
  
    <div className="article-page-contener">
      <Header />
      <div className="progress-bar" style={{ width: `${readingProgress}%` }}></div>
      <div className="article-layout">
        {/* Table of Contents sidebar */}
        {tocItems.length > 0 && (
          <aside className="toc-sidebar">
            <h4 className="toc-heading">Contents</h4>
            <ul className="toc-list">
              {tocItems.map((item, i) => (
                <li key={i} className={`toc-item toc-${item.level}`}>
                  <a href={`#toc-${i}`}>{item.text}</a>
                </li>
              ))}
            </ul>
          </aside>
        )}
      <div className="article-page">
        {article && article.coverImage && (
          <img
            src={article && article.coverImage}
            alt={article && article.title}
            className="article-image"
          />
        )}
        <div className="article-meta"></div>


          
          <div className="article-meta">
            <span><strong>Category: </strong> {article.category}</span>
            <span><strong>Written By:  <FaPenAlt /> </strong> { article.author==="sushensable"? "Sushen Sable": article.author}</span>
            <span><strong> <FaRegCalendarAlt /> :</strong> {article.date}</span>
            <span><FaClock /> {calcReadTime(article.content)} min read</span>
            <a  className="subscribe-btn" href="https://wa.me/919960652167?text=Hi%20I%20want%20to%20subscribe%20to%20your%20articles"><div><FaBell /> Subscribe</div></a>
            <button className="action-icon-btn" onClick={toggleBookmark} title={isBookmarked ? 'Remove bookmark' : 'Bookmark'}>
              {isBookmarked ? <FaBookmark /> : <FaRegBookmark />}
            </button>
            <button className="action-icon-btn" onClick={copyLink} title="Copy link"><FaCopy /></button>
            <button className="action-icon-btn" onClick={() => setShowQRModal(true)} title="QR Code"><FaQrcode /></button>
          </div>
           <TextToSpeech
           text={`Hello! Welcome back to Digital Journaling Article. Let's read the article together! ${article.content.replace(/<[^>]+>/g, ' ')}`}
        langPref={article.artLng || "en"}
        autoStart={false}
      />
          <p
            className="article-content"
            dangerouslySetInnerHTML={{ __html: article.content }}
          ></p>
         
{showLikeError && <span className="like-error">You have already liked this article</span>}
          <div className="article-actions">
              <div className="count-section">
                <span className="like-count"> {article.likes} Likes <button className="like-btn" onClick={handleLike}> <FaThumbsUp /> </button></span>
              <span className="view-btn" > {article.views}  Visits </span>
                </div>
          </div>

         <a href={`https://wa.me/?text=${encodeURIComponent(article.title + "\n" + article.description + "\nRead this article on Digital Journaling: "+ window.location.href  )}`}
        className="whatsapp-button-share"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="whatsaap-btn-icon" />
        <span className="whatsapp-share-btn-lable">Share on What's App</span>
      </a>
          <div className="comments-section">
            
            <ul>
              {comments && comments.length > 0 ? <h3 className="cmt-title">Comments ({comments.length})</h3> : <h6 className="cmt-title">No comments yet, be the first to comment!</h6>}
             
              {comments.map((comment, index) => (
                <>
                <li key={index} className="comment-card">
                  <div className="comment-header">
                    <strong>@ {comment.username}</strong> <span> &nbsp;&nbsp; {new Date(comment.createdAt).toLocaleString()}</span>
                    <span className="cmtlikes" onClick={() => handleCmteLike(comment.id)}>{comment.likes ? comment.likes : 0} ❤️ Likes </span>
                    {loginStatus && (
                      <button className="reply-btn" onClick={() => setReplyingTo(replyingTo === comment.id ? null : comment.id)}>
                        <FaReply /> Reply
                      </button>
                    )}
                  </div>
                  <p>{comment.text}</p>

                  {/* Reply input */}
                  {replyingTo === comment.id && (
                    <div className="reply-form">
                      <textarea
                        value={replyText}
                        onChange={e => setReplyText(e.target.value)}
                        placeholder="Write a reply..."
                        rows={2}
                      />
                      <button className="comment-submit-btn" onClick={() => handleReplySubmit(comment.id)}>Post Reply</button>
                      <button className="btn-cancel-reply" onClick={() => setReplyingTo(null)}>Cancel</button>
                    </div>
                  )}

                  {/* Nested replies */}
                  {comment.replies && comment.replies.length > 0 && (
                    <ul className="replies-list">
                      {comment.replies.map((reply, ri) => (
                        <li key={ri} className="comment-card reply-card">
                          <div className="comment-header">
                            <strong>@ {reply.username}</strong>
                            <span> &nbsp; {new Date(reply.createdAt).toLocaleString()}</span>
                          </div>
                          <p>{reply.text}</p>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
                </>
              ))}
            </ul>
            <div className="comment-form">
              <h3>Add Comment</h3>
            <input
              type="text"
              placeholder="Your Name "
              className="comment-user-input"
              value={user || ""}
              onChange={(e) => setUser(e.target.value)}
              disabled={loginStatus}
            />
            <textarea
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              placeholder="Add a comment..."
              disabled={!user}
            ></textarea>
            <button className="comment-submit-btn" onClick={handleCommentSubmit} disabled={!user}>Submit</button>
            {!user && <span className="login-meta-data">
              Either enter your name or  <a href="/login">Login</a> to add comment
              </span>}
              </div>
          </div>
             
          <div className="related-articles">
             <a  className="subscribe-btn-end" href='https://wa.me/919960652167?text=Hi%20I%20want%20to%20subscribe%20to%20your%20articles'><div><FaBell /> Subscribe</div></a>
            {relatedArticles && relatedArticles.length > 0 &&
            (<div>
              <h3>Related Articles</h3>
            <div className="related-article-list">
                {relatedArticles.map((article) => (
                  <Link to={`/blog/${article.slug}`} key={article.id} className="related-article-card-link">
                    <div className="related-article-card">
                      {article.coverImage && (
                        <img src={article.coverImage} alt={article.title} />
                      )}
                      <h3>{article.title}</h3>
                      <p dangerouslySetInnerHTML={{ __html: truncateContent(article.content, article.coverImage ? 70 : 250) }}></p>
                      <span className="related-read-more">
                        Read More →
                        </span>
                    </div>
                  </Link>
                ))}
              </div> 
              </div>)}
          </div>
         
<h4 className="social-heading">Share on </h4>
          <div className="social-share">
            
            <a href={`https://wa.me/?text=${encodeURIComponent(article.title + "\n" + article.description + "\nRead this article on Digital Journaling: " + window.location.href )}`} target="_blank" rel="noopener noreferrer"><FaWhatsapp /> </a>
            <a href={`https://www.linkedin.com/shareArticle?url=${window.location.href}`} target="_blank" rel="noopener noreferrer"><FaLinkedin /> </a>
            <a href={`https://twitter.com/intent/tweet?url=${window.location.href}`} target="_blank" rel="noopener noreferrer"> X</a>
          </div>

        </div>
      </div>  {/* end article-layout */}
  </div>  {/* end article-page-contener */}
<div className="share-on-whatsapp">
  <a
        href={`https://wa.me/?text=${encodeURIComponent(article.title + "\n" + article.description + "\nRead this article on Digital Journaling: "+ window.location.href  )}`}
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
        <span className="whatsapp-share-label">Share</span>
      </a>
  </div>

  {/* QR Code Modal */}
  {showQRModal && (
    <div className="qr-modal-overlay" onClick={() => setShowQRModal(false)}>
      <div className="qr-modal" onClick={e => e.stopPropagation()}>
        <h3>Scan to read this article</h3>
        <img
          src={`/api/blogs/qr/${article.slug}`}
          alt="QR Code"
          style={{ width: 200, height: 200 }}
        />
        <p style={{ fontSize: '13px', color: 'var(--muted-color)', marginTop: 8 }}>{window.location.href}</p>
        <button className="comment-submit-btn" onClick={() => setShowQRModal(false)}>Close</button>
      </div>
    </div>
  )}

  <Footer />
  </> );
};

export default ArticlePage;
